<p-fluid>
  <form [formGroup]="todoForm" class="flex flex-col gap-4 mt-2 mb-4">
    <p-floatlabel variant="on">
      <p-select
        formControlName="status"
        [invalid]="todoForm.controls.status.invalid && todoForm.controls.status.touched"
        [options]="allStatus"
        optionLabel="name"
      />
      <label>{{ 'internal.todos.status' | translate }}</label>
    </p-floatlabel>

    <p-floatlabel variant="on">
      <p-select
        formControlName="priority"
        [invalid]="todoForm.controls.priority.invalid && todoForm.controls.priority.touched"
        [options]="allPriorities"
        optionLabel="name"
      />
      <label>{{ 'internal.todos.priority' | translate }}</label>
    </p-floatlabel>

    <div class="flex flex-row gap-4 justify-between flex-desktop">
      <div>
        <label>{{ 'internal.todos.duedate' | translate }}</label>
        <p-datepicker
          formControlName="duedate"
          [invalid]="todoForm.controls.duedate.invalid && todoForm.controls.duedate.touched"
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [inline]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
      </div>

      <div>
        <label>{{ 'internal.todos.notification' | translate }}</label>
        <p-datepicker
          formControlName="notification"
          [invalid]="
            todoForm.controls.notification.invalid && todoForm.controls.notification.touched
          "
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [inline]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
      </div>
    </div>

    <div class="flex flex-col gap-4 flex-mobile">
      <p-floatlabel variant="on">
        <p-datepicker
          formControlName="duedate"
          [invalid]="todoForm.controls.duedate.invalid && todoForm.controls.duedate.touched"
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [touchUI]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
        <label>{{ 'internal.todos.duedate' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <p-datepicker
          formControlName="notification"
          [invalid]="
            todoForm.controls.notification.invalid && todoForm.controls.notification.touched
          "
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [touchUI]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
        <label>{{ 'internal.todos.notification' | translate }}</label>
      </p-floatlabel>
    </div>

    @if (loadingUsers()) {
      <p-skeleton height="2.625rem" />
    } @else {
      <p-floatlabel variant="on">
        <p-autocomplete
          [formControl]="assigneeControl"
          [suggestions]="filteredUsers()"
          (completeMethod)="_searchUser($event)"
          [lazy]="true"
          [completeOnFocus]="true"
          dataKey="_id"
          optionLabel="fullname"
        />
        <label>{{ 'internal.todos.assignee' | translate }}</label>
      </p-floatlabel>
    }

    <p-floatlabel variant="on">
      <textarea
        pTextarea
        formControlName="description"
        [invalid]="todoForm.controls.description.invalid && todoForm.controls.description.touched"
        rows="10"
        cols="30"
        style="resize: none"
        class="h-full"
      ></textarea>
      <label>{{ 'internal.todos.description' | translate }}</label>
    </p-floatlabel>
  </form>
</p-fluid>

<div class="flex justify-end gap-2">
  @if (todo._id != undefined && api.hasPermission('delete_todos')) {
    <p-button [label]="'general.delete' | translate" severity="danger" (onClick)="deleteTodo()" />
  }
  <p-button [label]="'general.cancel' | translate" severity="secondary" (onClick)="closeDialog()" />
  <p-button
    [label]="'general.save' | translate"
    [disabled]="!todoForm.valid"
    (onClick)="closeDialog(true)"
  />
</div>
